import React from 'react';
import {
  Modal,
  Button,
} from 'antd';
import { SpText } from 'components/DesignKit';

type Props = {
  uploadSuccessModalVisibility: Boolean,
  setUploadSuccessModalVisibility: Function,
};

const DisplayUploadSuccess = (props: Props) => {
  const {
    uploadSuccessModalVisibility,
    setUploadSuccessModalVisibility,
  } = props;

  const handleUploadSuccessModalCancel = () => {
    setUploadSuccessModalVisibility(false);
  };

  const handleUploadSuccessModalSave = () => {
    setUploadSuccessModalVisibility(false);
  };

  return (
    <Modal
      title="Document Uploaded Successfully"
      visible={uploadSuccessModalVisibility}
      onCancel={handleUploadSuccessModalCancel}
      footer={[
        <Button key="ok" type="primary" onClick={handleUploadSuccessModalSave}>
          OK
        </Button>,
      ]}
      centered
      maskClosable={false}
      closable
    >
      <div style={{ padding: '20px' }}>
        <SpText style={{ fontWeight: 'bolder', display: 'block', marginBottom: '12px' }}>
          Thank you! Your document has been uploaded.
          We’re currently analyzing it, and you’ll be notified once it’s ready for the next step in inventory processing.
        </SpText>
      </div>
    </Modal>
  );
};

export default DisplayUploadSuccess;
